export default [
    {
        path: 'confirmacao-coleta',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-confirmacao-coleta' */
            '@/views/exame-laboratorial/confirmacao-coleta/Index'
        ),
        redirect: 'confirmacao-coleta/index',
        children: [
            {
                name: 'exame-laboratorial-confirmacao-coleta-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-confirmacao-coleta' */
                    '@/views/exame-laboratorial/confirmacao-coleta/List.vue'
                ),
            },
        ],
    },
]
